<template>
    <div>
        <b-card no-body v-if="mostrarMenu">
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - Relatórios</span>
                </h4>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('GESCON-CONT-REL-01')"
                                :href="`#/gescon/relatorioscontratos/consumoqtdporsubitem`">
                                <strong> Consumo de quantidade por subitem </strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('GESCON-CONT-REL-01')"
                                :href="`#/gescon/relatorioscontratos/comprometimentossemregistropagamento`">
                                <strong> Comprometimentos sem registro de pagamento </strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('GESCON-CONT-REL-02')"
                                :href="`#/gescon/relatorioscontratos/relacaonotasfiscais`">
                                <strong>Relação de Notas Fiscais</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('GESCON-CONT-REL-03')"
                                :href="`#/gescon/relatorioscontratos/comprometimentosporcontrato`">
                                <strong>Comprometimentos por Contrato</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('GESCON-CONT-REL-04')"
                                :href="`#/gescon/relatorioscontratos/contratosporgestor`">
                                <strong>Contratos por Gestor</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('GESCON-CONT-REL-05')"
                                :href="`#/gescon/relatorioscontratos/valorespagosporcontratos`">
                                <strong>Valores Pagos por Contratos</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    computed: {
        mostrarMenu() {
            return this.$route.name == 'Gescon_Relatorios_Contratos'
        }
    },
}
</script>
